module.exports = __webpack_public_path__ + "static/media/Artboard4.52e8f031.png";